import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);

// Overdue is only possible for Required training that has an end date and is
// not completed. A missing end date (no due date, or Optional training) is
// never overdue.
export const isProgramOverdue = (program, now = dayjs()) => {
  if (!program?.endDate || program?.isOptional) {
    return false;
  }
  if (program?.status?.toLowerCase() === "completed") {
    return false;
  }
  return dayjs(now).isAfter(dayjs.utc(program.endDate));
};

export const getProgramStatus = (program, now = dayjs()) => {
  let status = program?.status?.toLowerCase() || "notstarted";
  let color = "var(--orange-500)";
  if (status === "completed") {
    color = "var(--green-500)";
  } else if (isProgramOverdue(program, now)) {
    status = "overdue";
    color = "var(--red-500)";
  } else if (
    status === "inprogress" ||
    status === "started" ||
    status === "incomplete"
  ) {
    status = "inprogress";
    color = "#0EA5E9";
  }
  return { status, color };
};

// Splits a Required program's start-to-end range evenly across its
// milestones. Optional training and programs without an end date have no
// milestone dates.
export const getMilestoneDueDates = (program) => {
  if (program?.isOptional || !program?.startDate || !program?.endDate) {
    return [];
  }
  const start = dayjs(program.startDate);
  const end = dayjs(program.endDate);
  const count = program?.milestones?.length || 1;
  const interval = end.diff(start) / count;

  const dates = [];
  for (let i = 1; i <= count; i++) {
    dates.push(start.add(interval * i, "millisecond"));
  }
  return dates;
};
